import { Component } from 'react'
import { gql } from "@apollo/client"
import { Col, Row, Input } from 'reactstrap'
import ListingFilters from "../../Material/ListingFilters"

const AllTPAsQuery = gql`
  query AllTPAs {
    optionsList: allTpas {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`

class TPAAdjustersListHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            configurations: null,
        }
    }

    getFilterConfigurations = () => [
        { type: "select", name: "tpaId", title: "TPA", placeholder: "Filter By TPA", optionsQuery: AllTPAsQuery, valueSelector: "id", labelSelector: "name", showFilter: true },
    ]

    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }

    updateSearchTerm = (searchTerm) => {
        this.props.setFilterValues({ ...this.props.filterValues, searchTerm })
    }

    removeFilter = (filterName) => {
        let filterValues = this.props.filterValues
        if (Object.keys(filterValues).includes(filterName)) {
            delete filterValues[filterName]
            this.props.setFilterValues({ ...this.props.filterValues })
        }
    }

    getValueByFilterType = (filterConfig, value) => {
        if (filterConfig.type !== "select") return value
        const option = filterConfig.options?.find(option => option.value === value)
        return option?.label || value
    }

    setFilters = () => {
        const configurations = this.getFilterConfigurations().filter(filter => filter.showFilter).map(filter => {
            if (filter.optionsQuery) {
                this.props?.apolloClient?.query({ query: filter.optionsQuery }).then(result => {
                    const options = result?.data?.optionsList?.edges?.map(({ node }) => ({
                        value: node[filter.valueSelector],
                        label: node[filter.labelSelector],
                    })) || []
                    filter.options = options
                    delete filter.optionsQuery
                    this.setState({ configurations: [...configurations] })
                })
            }
            return filter
        })
        this.setState({ configurations })
    }

    getFiltersLength = () => {
        const keys = Object.keys(this.props.filterValues)
        const count = keys.filter(key => this.props.filterValues[key] !== null && this.state.configurations && this.state.configurations.find(setting => setting.name === key)?.showFilter).length
        return count ? ` | ${count}` : ""
    }

    componentDidMount() {
        this.setFilters()
    }

    render() {
        return (
            <Row className="pb-2">
                {this.state.openModal === "viewFilters" &&
                    <ListingFilters
                        open={this.state.openModal === "viewFilters"}
                        handleClose={() => this.toggleModal("")}
                        target="viewFilters"
                        filterValues={this.props.filterValues}
                        setFilterValues={this.props.setFilterValues}
                        filters={this.state.configurations}
                    />}
                <Col xs={12} className="mt-2">
                    <Row>
                        <Col xs={6}>
                            <span className="driver-search-filter">
                                <Input type="text" name="searchTerm" placeholder="Search" onChange={(e) => this.updateSearchTerm(e.target.value)} />
                                <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                            </span>
                        </Col>
                        <Col className="mt-1 p-0">
                            <a id="viewFilters" className="driver-list-button" onClick={() => this.toggleModal("viewFilters")}>
                                <i className="fa fa-sliders fa-solid fa-2x" aria-hidden="true"></i>
                                {this.getFiltersLength()}
                            </a>
                        </Col>
                    </Row>
                </Col>
                {this.props.filterValues && this.state.configurations && <Col xs={12} className="mt-2 search-filter-container">
                    {Object.keys(this.props.filterValues).filter(key => this.props.filterValues[key] !== null && this.state.configurations.find(setting => setting.name === key)?.showFilter).map(key =>
                        <span className="search-filter-preview" key={key}>
                            <span>
                                <i className="fa fa-times-circle" onClick={() => this.removeFilter(this.state.configurations.find(setting => setting.name === key).name)}></i>&nbsp;&nbsp;
                                {this.state.configurations.find(setting => setting.name === key).title}
                            </span>
                            {this.getValueByFilterType(this.state.configurations.find(setting => setting.name === key), this.props.filterValues[key])}
                        </span>
                    )}
                </Col>}
            </Row>
        )
    }
}

export default TPAAdjustersListHeader
